const actions = {
  COPY_ITEM: 'copyTarget/COPY_ITEM',
  PASTE_ITEM: 'copyTarget/PASTE_ITEM',
  SET_STATE: 'copyTarget/SET_STATE',
}

export default actions
